import React, { forwardRef } from 'react';
import { Col, Row } from '@ag1/ui';
import clsx from 'clsx';
import { ReviewItem, Reviews, SanityKeyed } from 'types/studio/studio';
import styles from './styles.module.scss';
import ReviewsCard from '../ReviewsCard/ReviewsCard';

type Props = {
  items: Reviews['items'];
  textColor?: string;
  sliderActive?: boolean;
  showIndividualReviewBackground: boolean;
};

const ReviewsContent = forwardRef<HTMLDivElement, Props>(
  ({ items, sliderActive, textColor, showIndividualReviewBackground }, ref) => (
    <div className={clsx(styles.content, sliderActive && styles.sliderActive)} ref={ref}>
      <Row className={styles.row}>
        {items.map((item: SanityKeyed<ReviewItem>) => {
          const { _key: key } = item;

          return (
            <Col key={key} span={{ xxs: 12, s: 6, l: 4 }} className={styles.col}>
              <ReviewsCard
                {...item}
                textColor={textColor}
                showIndividualReviewBackground={showIndividualReviewBackground}
              />
            </Col>
          );
        })}
      </Row>
    </div>
  )
);

if (process.env.NODE_ENV !== 'production') {
  ReviewsContent.displayName = 'ReviewsContent';
}

export default ReviewsContent;
